var map = {
	"./background.jpg": "1100",
	"./background111.jpg": "b9c1",
	"./background2 (2).jpg": "feb7",
	"./background2.jpg": "35a5",
	"./background22 (2).jpg": "dc70",
	"./background22.jpg": "9bba",
	"./coloredeer-logo.jpg": "6749",
	"./coloredeer.jpg": "979c",
	"./coloredeer.png": "5b1e",
	"./coloredeer2..jpg": "9a9e",
	"./coloredeer_white - 副本.png": "2742",
	"./coloredeer_white - 鍓湰.png": "2cbb",
	"./hetong.png": "d96d",
	"./house.jpg": "7e71",
	"./lock.jpg": "ec2d",
	"./login.jpg": "d0cf",
	"./logo.jpg": "b640",
	"./mychoice.jpg": "878d",
	"./pricing.jpg": "429c",
	"./register.jpg": "89ea",
	"./slider.png": "fd2b",
	"./slider1.jpg": "4dce",
	"./slider2.jpg": "9a02",
	"./stracraft.jpg": "69be",
	"./tuozhan_logo.png": "fa30",
	"./unnamed.jpg": "1d40",
	"./vuetify.svg": "6dff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";